<template>
  <div class="autocomplete">
    <input type="text"
      :class="{'disabled-autocomplete': disableInput}"
      class="input-autocomplete" 
      :disabled="disableInput"
      v-model="query.value"
      v-on:keyup="onInput( $event )"
      @blur="handleVisible"
    >
    <div class="loading-box">
      <div class="loader-autocomplete" v-show="loadingIco"></div>
    </div>
    <ul class="li-options" ref="optionsList" v-show="visible">
      <li 
        v-for="(item , index) in items"
        :key="index"
         @mousedown="itemClicked(index)"
      >
        <slot name="custom-items" :data="item">{{item}}</slot>
      </li>
    </ul>
  </div>
</template>
<script>
import { CancelToken } from 'axios'

  const API_URL = process.env.VUE_APP_API;
  let source
  let setTime
  export default {
    props: {
      disableInput: Boolean,
      endpoint: String,
      data:String,
    },
    data(){
      return {
        query:{
          value: this.data,
        },
        items:[],
        visible:false,
        loadingIco:false,
        click:{
          select:0
        }
      }
    },
    watch: { 
      data(newVal, oldVal) {
        return this.query.value = newVal
      }
    },
    methods:{

      onInput( event ){
        this.$emit('input' , event)
        this.searchData()
      },
      clearData(){
        this.visible = false
        this.loadingIco = false
        this.items = []
      },
      itemClicked(index) {
        this.click.select = index
        this.selectItem()

      },
      handleVisible(){
        this.visible = false
        this.loadingIco = false
      },
      selectItem() {
        this.$emit('select:item' , this.items[this.click.select])
        this.handleVisible()
      },
      setEndpoint(){
        return this.$props.endpoint.replace("${param}", this.query.value)
      },
      searchData(){
        this.loadingIco = true
        let _SELF = this    
          if(source){
            source.cancel()
          }
        source = CancelToken.source()
        const cancelToken = source.token
          if (this.query.value.length < 3) {
            return this.clearData()
          }
        clearTimeout(setTime)
        setTime = setTimeout(function(){
          _SELF.$http.get( API_URL + _SELF.setEndpoint(), {
            cancelToken , 
            headers: { Token: localStorage.getItem("access_token") }
            }).then(res => {
              let result = res.data.data
                if( !Array.isArray(result) ){
                  return _SELF.clearData()
                }
              _SELF.items = result
              _SELF.loadingIco = false
              _SELF.visible = true
            })
         }, 500);
      }
    }
  }
</script>

<style scoped >
.autocomplete{
  width: 100%;
  position: relative;

}
.relate {

  position: relative;
}

.input-autocomplete {
  width: 100%;
  border-radius: 5px;
}
.li-options {
    position: absolute;
    background: #f1f1f1;
    width: 100%;
    z-index: 2;
    list-style-type: none;
    box-shadow: 0 0 1px #00000087;
    top: 40px;
    padding-left: 0;
    overflow-y: overlay;
    max-height: 120px;
    cursor: pointer;

}
.li-options li {
  padding-left: 25px;
    border-bottom: 1px solid #c5c5c5;
}
.li-options li:hover {
  background: white;
}
.loader-autocomplete {

    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 100%;
    width: 19px;
    height: 20px;
    animation: spin 1s linear infinite;
}
.loading-box {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>